import { keptValues } from "@front/plugins/keep";
import { ready, withEl } from "@front/utils";
import { get } from "lodash-es";
import Cookies from "js-cookie";

function scrollToLastProduct () {

    if (document.querySelector('.js-productlist') == null) {
        return;
    }

    const productScroll = get(keptValues, 'product-scroll', null);

    if (!productScroll) {
        return;
    }

    const { id_product, id_product_attribute } = productScroll;
    withEl(`[data-id-product="${id_product}"][data-id-product-attribute="${id_product_attribute}"]`, (el) => {
        el.scrollIntoView({ block: 'center' });

        delete keptValues['product-scroll'];
        Cookies.set('keep', JSON.stringify(keptValues));
    });

}

ready(() => {

    scrollToLastProduct();

});
